import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { driversActions } from '../../store';

const DriverValue = ({ driverUniqueId }) => {
  const dispatch = useDispatch();
  const driver = useSelector((state) => state.drivers.items[driverUniqueId]);
  const [fetchedName, setFetchedName] = useState(null);
  const [fetching, setFetching] = useState(false);

  // Se não encontrou no cache, tenta buscar diretamente
  useEffect(() => {
    if (!driver && driverUniqueId && !fetching && !fetchedName) {
      setFetching(true);
      fetch(`/api/drivers?uniqueId=${encodeURIComponent(driverUniqueId)}`)
        .then((response) => {
          if (response.ok) return response.json();
          throw new Error('Driver not found');
        })
        .then((data) => {
          if (data && data.length > 0) {
            const foundDriver = data[0];
            setFetchedName(foundDriver.name);
            // Atualiza o cache global
            dispatch(driversActions.refresh([...Object.values({}), foundDriver]));
          }
        })
        .catch(() => {
          // Driver não encontrado - mantém o ID
        })
        .finally(() => setFetching(false));
    }
  }, [driver, driverUniqueId, fetching, fetchedName, dispatch]);

  if (driver?.name) return driver.name;
  if (fetchedName) return fetchedName;
  if (fetching) return '...';
  return driverUniqueId || '-';
};

export default DriverValue;
